// Core and Libs imports
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SidebarModule } from 'ng-sidebar';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BlockUIModule } from 'ng-block-ui';
import { DragDropModule } from '@angular/cdk/drag-drop';
// Local imports
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UsersComponent } from './components/users/users.component';
import { UsersAssignsComponent } from './components/users-assigns/users-assigns.component';
import { HeaderComponent } from './components/header/header.component';
import { NotificacionesComponent } from './components/notificaciones/notificaciones.component';
import { SolicitudCompraComponent } from './components/solicitud-compra/solicitud-compra.component';
import { OrdenCompraComponent } from './components/orden-compra/orden-compra.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { RequestInterceptorService } from './services/request-interceptor.service';
import { HttpErrorInterceptor } from './services/error-interceptor.service';
import { RolAssignsComponent } from './components/rol-assigns/rol-assigns.component';
import { RolesComponent } from './components/roles/roles.component';
import { PermissionsComponent } from './components/permissions/permissions.component';
import { ConfigNotificacionesComponent } from './components/config-notificaciones/config-notificaciones.component';
import { SubscriptionComponent } from './components/subscription/subscription.component';
import { BinnacleComponent } from './components/binnacle/binnacle.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    UsersComponent,
    UsersAssignsComponent,
    HeaderComponent,
    NotificacionesComponent,
    SolicitudCompraComponent,
    OrdenCompraComponent,
    RolAssignsComponent,
    RolesComponent,
    PermissionsComponent,
    ConfigNotificacionesComponent,
    SubscriptionComponent,
    BinnacleComponent
  ],
  imports: [
    BrowserModule,
    SidebarModule.forRoot(),
    BlockUIModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    DragDropModule,
    ReactiveFormsModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
